import config from '../config';

const routesThatExpect401 = ['/login'];

class Api {
    constructor() {

        this.apiUrl = config.Api.baseUrl;
        this.headers = {
            'Accept': 'application/json, text/html',
            'Content-Type': 'application/json'
        };

        const token = localStorage.getItem('token');
        if (token) {
            this.loadToken(localStorage.getItem('token'));
        }

        this.options = {};
    }

    handleLogin(data) {
        if (data && data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('refresh_token', data.refresh_token);
            this.loadToken(data.token);
            return data;
        }
        else {
            return {
                error: data
            }
        }
    }

    loadToken(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }

    makeRequest(route, method, body, caller = false) {

        let options = {
            method: method,
            headers: this.headers
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        return fetch(this.apiUrl + route, options)
            .then((response) => {
                if (response.status < 200 || response.status >= 400) {

                    if (response.status === 401 && routesThatExpect401.indexOf(route) === -1) {
                        localStorage.removeItem('token');

                        if (caller) {
                            this.makeRequest('/refresh-token', 'POST', {
                                refresh_token: localStorage.getItem('refresh_token')
                            }).then(data => {
                                if (this.handleLogin(data) ) {
                                    caller();
                                }
                            })
                            .catch( (e) => {
                                window.location = "/";
                            });

                            return Promise.reject(response);
                        }
                        else {
                            // window.location = "/";
                        }
                    }

                    return Promise.reject(response);
                }
                else {
                    return response;
                }
            })
            .then(response => response.json())
    }
}

const handleUnauthorized = (status, route) => {
    const routesThatExpect401 = ['/login'];
    if (status === 401 && routesThatExpect401.indexOf(route) === -1) {
        localStorage.removeItem('token');
        window.location = "/";
    }
};

const apiInstance = new Api();

export default apiInstance;


// WEBPACK FOOTER //
// ./src/utils/Api.js